import styled, { css } from 'styled-components'
import { colors } from '../../../../../../shared/styles/colors'

export const InfoText = styled.span`
  color: ${colors.gray7};
  font-family: Inter, Roboto, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
`

export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  margin-top: 8px;
`
